import React, { useEffect, useState } from "react";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import toast from "react-hot-toast";
import SimpleLoader from "../../components/Loader/SimpleLoader";
import { ArrowDownTrayIcon, BookOpenIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import PdfCoverThumb from "../../components/PdfFlipBook/PdfCoverThumb";

const Ertegiler = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await searchFilesByModule({
          module_code: "ertegiler",
        });
        if (response?.files?.length) {
          setFiles(response.files);
        } else {
          toast.error("Ертегілер табылмады.");
        }
      } catch (err) {
        toast.error("Ертегілерді жүктеу кезінде қате орын алды.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, []);

  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file.file_url;
    link.download = file.file_name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success(`«${file.label || file.file_name}» жүктелді`);
  };

  return (
    <div className="p-8 max-w-7xl mx-auto text-center">
      <h1 className="text-3xl font-bold text-[#674DA2] my-8">Ертегілер</h1>

      {loading ? (
        <div className="flex justify-center items-center py-10">
          <SimpleLoader className="w-10 h-10 text-[#674DA2]" />
        </div>
      ) : files.length === 0 ? (
        <p className="text-center text-gray-600">Ертегілер табылмады.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
          {files.map((file) => (
            <div
              key={file.uuid}
              onClick={() => navigate(`/ertegiler/${file.uuid}`)}
              className="bg-white rounded-xl overflow-hidden shadow hover:scale-[1.05] hover:ring-2 hover:ring-[#674DA2] transition-all flex flex-col items-center"
            >
              {file.file_name?.toLowerCase().endsWith(".pdf") ? (
                <PdfCoverThumb
                  url={file.file_url}
                  cacheKey={file.uuid}
                  alt={file.label || file.file_name}
                  className="w-full h-auto"
                  fallback={
                    <div className="h-48 w-full bg-gradient-to-br from-[#674DA2] to-[#8a6fc4] flex flex-col items-center justify-center text-white">
                      <BookOpenIcon className="w-16 h-16 mb-2 opacity-90" />
                      <span className="text-sm font-semibold px-4 line-clamp-2">
                        {file.label || file.file_name}
                      </span>
                    </div>
                  }
                />
              ) : (
                <img
                  src={file.file_url}
                  alt={file.label}
                  className="h-45 w-full object-cover"
                />
              )}
              <div className="p-4 flex flex-col items-center text-center">
                <h2 className="font-semibold text-sm text-[#674DA2] mb-2 line-clamp-2">
                  {file.label || file.file_name}
                </h2>
                <button
                  onClick={() => navigate(`/ertegiler/${file.uuid}`)}
                  className="flex items-center gap-1 bg-[#674DA2] text-white px-5 py-1 text-md rounded-md hover:bg-[#5a4190] transition"
                >
                  <BookOpenIcon className="w-6 h-6" />
                  Оқу
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Ertegiler;
